import KioskHeader from './KioskHeader';

export default KioskHeader;
